// extracted by mini-css-extract-plugin
export default {"installation_address_container":"style_installation_address_container__CQpX+","no_margin":"style_no_margin__GWxFg"};